import { PERCENTAGE } from 'store/kpis';

export const prettyValue = (value, unit) => {
  if (typeof value !== 'number') return '';
  if (unit.toUpperCase() === PERCENTAGE.toUpperCase()) return value.toFixed(value % 1 ? 1 : 0);

  return value.toLocaleString('de-CH', { useGrouping: 'min2', maximumFractionDigits: 3 });
};
